<template>
  <b-card no-body class="my-2">
    <b-card-header class="card-header-results">
      <div class="card-header-result-name">
      <b-icon
        @click="toggleCollapse()"
        variant="primary"
        :icon="collapsed ? 'dash-square' : 'plus-square'"
        v-b-tooltip.hover.top :title=" collapsed ? $gettext('more') : $gettext('less')"
        class="mx-2" />
        <span style="font-size:1rem">
          <strong>{{ result.label }} - to: {{ result.to_name }}</strong>
        </span>
      </div>
      <div class="price-and-status">
        <span class="price-start-at" style="cursor: pointer;" @click="$emit('priceDetails')"> <b><translate>price</translate>: {{ result.price + result.tax }} EUR</b></span>
      </div>
    </b-card-header>
    <b-card-body v-if="!collapsed">
      <b-row>
        <b-col md="4">
          <img :src="result.image" class="img-fluid w-100 d-block" />
        </b-col>
        <b-col md="8">
          <div class="d-flex justify-content-between align-content-center result-summary p-2 mb-3">
            <span><strong><translate>Departure from</translate>: </strong>{{ result.from_name }}</span>
            <span><strong><translate>Arrival at</translate>: </strong>{{ result.to_name }}</span>
          </div>
          <b-row>
            <b-col sm="12" class="d-flex align-items-center">
              <p>{{ result.description }}</p>
            </b-col>
            <b-col sm="6">
              <b-card no-body class="p-3 bg-light">
                <b-row>
                  <b-col class="col-sm-6"><strong><translate>Departure</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ outDep }}</b-col>
                  <b-col class="col-sm-6"><strong><translate>From</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ result.dep_pick_up_details }}</b-col>
                  <b-col class="col-sm-6"><strong><translate>Arrival</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ outArr }}</b-col>
                  <b-col class="col-sm-6"><strong><translate>At</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ result.dep_drop_off_details }}</b-col>
                  <template v-if="result.out_duration">
                    <b-col class="col-sm-6"><strong><translate>Duration</translate>: </strong></b-col>
                    <b-col class="col-sm-6">{{ result.out_duration}}</b-col>
                  </template>
                </b-row>
              </b-card>
            </b-col>
            <b-col sm="6">
              <b-card no-body class="p-3 bg-light">
                <b-row>
                  <b-col class="col-sm-6"><strong><translate>Return</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ inDep }}</b-col>
                  <b-col class="col-sm-6"><strong><translate>From</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ result.dest_pick_up_details }}</b-col>
                  <b-col class="col-sm-6"><strong><translate>Arrival</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ inArr }}</b-col>
                  <b-col class="col-sm-6"><strong><translate>At</translate>: </strong></b-col>
                  <b-col class="col-sm-6">{{ result.dest_drop_off_details }}</b-col>
                  <template v-if="result.out_duration">
                    <b-col class="col-sm-6"><strong><translate>Duration</translate>: </strong></b-col>
                    <b-col class="col-sm-6">{{ result.in_duration }}</b-col>
                  </template>
                </b-row>
              </b-card>
            </b-col>
            <b-col md="12" v-if="showBook">
              <hr>
              <b-button variant="warning" size="sm" class="float-right" @click="$emit('book')">
                <b-icon icon="card-checklist" class="mr-2"/> <translate>Book</translate>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment'

const getDate = (val) => {
  const m = moment.unix(val)
  return m.format('DD-MM-YYYY')
}

export default {
  props: {
    result: {
      type: Object,
      mandatory: true
    },
    params: {
      type: Object,
      mandatory: true
    },
    expanded: {
      type: Boolean,
      default: true
    },
    showBook: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      collapsed: false
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  },
  created () {
    this.collapsed = !this.expanded
  },
  computed: {
    outDep () { return getDate(this.result.out_departure) },
    outArr () { return getDate(this.result.out_arrival) },
    inDep () { return getDate(this.result.in_departure) },
    inArr () { return getDate(this.result.in_arrival) }
  }
}
</script>
